import { render, staticRenderFns } from "./dataTable.vue?vue&type=template&id=59237bc8"
import script from "./dataTable.vue?vue&type=script&lang=js"
export * from "./dataTable.vue?vue&type=script&lang=js"
import style0 from "./dataTable.vue?vue&type=style&index=0&id=59237bc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports